import React from 'react';
import { ImageIcon } from 'lucide-react';
import type { BcmPhoto } from '../../data/photos';
type PhotoFrameProps = {
  photo: BcmPhoto;
  className?: string;
  /** Tailwind aspect ratio utility, e.g. "aspect-[4/5]". */
  ratio?: string;
  rotate?: string;
};

/**
 * Renders a real BCM photograph. Until the real file URL is added to
 * data/photos.ts, the frame shows a neutral "Add Image here" placeholder —
 * no stock or generated people are ever substituted in.
 */
export function PhotoFrame({
  photo,
  className = '',
  ratio = 'aspect-[4/3]',
  rotate = ''
}: PhotoFrameProps) {
  return <figure className={`overflow-hidden rounded-[18px] border-2 border-brand-navy bg-brand-blue ${photo.src ? ratio : ''} ${rotate} ${className}`} data-id="element-365" data-mp="269swd15xip5x">
      {photo.src ?
    // The ratio lives on the figure; the image fills it completely. An
    // aspect class on the <img> itself loses to the file's intrinsic ratio,
    // which left a strip of frame background showing.
    <img src={photo.src} alt={photo.alt} loading="lazy" className="h-full w-full object-cover" data-id="element-366" data-mp="gs46bgtwdzfa" /> : <div className={`${ratio} flex w-full flex-col items-center justify-center gap-2 px-4 py-6 text-center`} data-id="element-367" data-mp="ptu73d9o6apq">
          <ImageIcon aria-hidden="true" className="h-6 w-6 text-brand-navy" data-id="element-368" data-mp="ut6rlrd2j5p5" />
          <p className="font-meta text-[13px] font-semibold text-brand-navy" data-id="element-369" data-mp="3u8btb9a6mcs9">Add Image here</p>
        </div>}
    </figure>;
}